<template>
    <div>
        <!-- {{data}} -->
        <Comprehension
            :showAnswerField="data.showAnswerField"
            :currentQuestion="data.currentQuestion"
            v-if="
                data.currentQuestion.question_type ==
                    questionTypes.COMPREHENSION ||
                data.currentQuestion.question_type == questionTypes.TC
            "
        />
        <SingleAnsQuePrivew
            :showAnswerField="data.showAnswerField"
            :currentQuestion="data.currentQuestion"
            v-if="
                data.currentQuestion.question_type ==
                    questionTypes.SINGLE_CORRECT ||
                data.currentQuestion.question_type ==
                    questionTypes.ASSERTION_REASON
            "
        />
        <MultipleCorrectPrivew
            :showAnswerField="data.showAnswerField"
            :currentQuestion="data.currentQuestion"
            v-if="
                data.currentQuestion.question_type ==
                questionTypes.MULTIPLE_CORRECT
            "
        />
        <IntegerPrivew
            :showAnswerField="data.showAnswerField"
            :currentQuestion="data.currentQuestion"
            v-if="data.currentQuestion.question_type == questionTypes.INTEGER"
        />
        <SubjectivePrivew
            :showAnswerField="data.showAnswerField"
            :currentQuestion="data.currentQuestion"
            v-if="
                data.currentQuestion.question_type == questionTypes.SUBJECTIVE ||   data.currentQuestion.question_type == questionTypes.SUBJECTIVEINTEGER
            "
        />
        <MatrixMatchPrivew
            :showAnswerField="data.showAnswerField"
            :currentQuestion="data.currentQuestion"
            v-if="
                data.currentQuestion.question_type == questionTypes.MATRIX_MATCH
            "
        />

        <MatrixMatchOptionPrivew
            :showAnswerField="data.showAnswerField"
            :currentQuestion="data.currentQuestion"
            v-if="
                data.currentQuestion.question_type ==
                questionTypes.MATRIX_MATCH_OPTION
            "
        />
    </div>
</template>

<script>
import { mapMutations } from "vuex";

import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";

export default {
    props: ["data", "onClose"],
    components: {
        Comprehension,
        SingleAnsQuePrivew,
        MultipleCorrectPrivew,
        IntegerPrivew,
        SubjectivePrivew,
        AssertionReasonPrivew,
        MatrixMatchOptionPrivew,
        MatrixMatchPrivew,
    },
    mounted() {
        this.questionTypes = this.QUE_TYPES;
    },
    data() {
        return {
            questionTypes: {},
        };
    },
    methods: {},
};
</script>

<style>
</style>